import { Component, inject } from '@angular/core';
import { LocalCsvService } from '../../../../../../../services/local-csv/local-csv.service';

@Component({
  selector: 'csv-phone-updated',
  standalone: true,
  imports: [],
  templateUrl: './updated.component.html',
  styleUrl: './updated.component.css',
})
export class UpdatedComponent {
  constructor() {}

  localCSVService = inject(LocalCsvService);

  get updatedPhoneNumbers() {
    return this.localCSVService.getUpdated;
  }
}
